import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { StoreService } from 'src/app/services/store.service'
import { HelperService } from 'src/app/services/helper.service';
import { ActionSheetController, NavController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import { AuthConstants } from 'src/app/config/auth-constants'
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';
import { LoadingService } from 'src/app/services/loading.service'
import firebase from 'firebase/compat/app';
import * as _ from 'lodash';
// import { resourceLimits } from 'worker_threads';



declare var Razorpay: any;
@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.page.html',
  styleUrls: ['./checkout.page.scss'],
})
export class CheckoutPage implements OnInit {
  productObj: any = {};
  userId: any;
  paymentID: any;
  custInfoObj: any = {};
  address: any = [];
  selectedRadioItem: any;
  house_flat_number: any;
  landmark: any;
  isAddressUpdate: boolean = false;
  isAddressEdit: boolean = false;
  timeSlot: any = "12:00PM-05:00PM";
  selectedRadioPaymentMode: any;
  allShipAddArr: any = [];
  radioa: any = 0;
  //qty:number=1
  pincode: any;
  isPromoActiveFlag: any;
  promotionID: any;
  checkoutObj: any = {};
  city = localStorage.getItem('city');
  sCity: any;
  state: any;
  backPageFlag: any = {};
  addressVisible: boolean = false;
  apply: boolean = true;
  spotCoins: any = 0;
  totalAmount: any;
  spotCoinPay: any;
  spotcash: any;
  spotCoinsapplied: boolean = false;
  spotCashapplied: boolean = false;
  spotCashPay: any;
  addressVisibleLess: any;
  data: any;
  products: any = [];
  paymentMode: any = "POD";
  price: any;
  qty: any;
  product_id: any;
  result: any;
  dob: any;
  email1: any;
  phone: any;
  id: any;
  name: any;
  spotCoinsInitial: any;
  check: boolean = false;
  check1: boolean = false;
  delFee: any;
  cartObject: any = {};

  constructor(
    private loader: LoadingService,
    private userService: UserService,
    private toast: ToastService,
    private routerActivate: ActivatedRoute,
    private router: Router,
    private authService: StoreService,
    public actionSheetController: ActionSheetController,
    public alertController: AlertController,
    private navController: NavController) {

  }

  ngOnInit() {
    this.cartObject = this.userService.cartObject;

    this.userService.initialize(firebase.auth().currentUser.uid);

    console.log("firebase.auth().currentUser.uid ", firebase.auth().currentUser.uid)
    console.log("cartObject ", this.cartObject)

    let a = {
      uid: this.userService.uid
    }
    // this.userService.getUserDetails(a).subscribe((res: any) => {
    //   console.log(res);
    //   this.spotCoins = res.spotCoins;
    //   this.spotCoinsInitial = res.spotCoins;
    //   this.dob = res.dob;
    //   this.email1 = res.email1;
    //   this.name = res.name;
    //   this.phone = res.phone
    //   this.id = res._id;
    //   this.address = res.address;
    //   if (this.address.length > 0) {
    //     this.custInfoObj = this.address[0]
    //   } else {
    //     this.custInfoObj = "";
    //   }
    //   console.log(this.custInfoObj)
    //   this.radioGroupChangePayment('event');
    // })
  }

  ionViewWillEnter() {
    this.fetchAllShippingAddress();
  }

  fetchAllShippingAddress() {
    let a = {
      uid: this.userService.uid
    }
    this.userService.getUserDetails(a).subscribe((res: any) => {
      this.spotCoins = res.spotCoins;
      this.spotCoinsInitial = res.spotCoins;
      this.dob = res.dob;
      this.email1 = res.email1;
      this.name = res.name;
      this.phone = res.phone
      this.id = res._id;
      this.address = res.address;
      if (this.address.length > 0) {
        this.radioa = 0;
        this.custInfoObj = this.address[0]
      } else {
        this.custInfoObj = "";
      }
    })
  }

  goBack() {
    this.navController.pop();

  }
  goHome() {
    this.router.navigate(['/'])
  }

  radioGroupChange(event) {
    //console.log("radioSelect", event.detail.value);
    this.selectedRadioItem = event.detail.value;
  }
  radioGroupChangePayment(event) {
    // console.log("radioSelectPayment", event.detail.value);
    this.selectedRadioPaymentMode = this.paymentMode;
    if (this.selectedRadioPaymentMode == 'POD' && this.backPageFlag.backPageFlagInfo == 'gift') {
      this.toast.presentToast("POD is not available for buying Gift Card")
    }
    console.log(this.selectedRadioPaymentMode)
  }

  changeSuit(e) {
    this.timeSlot = e.target.value
    //console.log("change vales from time drop down", this.timeSlot)
  }

  //for offline checkout
  payPOD() {
    if (Object.keys(this.cartObject).length > 0) {
      this.data = this.cartObject.productDetailArr;
      this.delFee = this.cartObject.deliveryfees;
      for (var x in this.data) {
        if (localStorage.getItem('retailerEnabled') == "1") {
          this.products.push({ _id: this.data[x]._id, qty: this.data[x].qty, retailerEnabled: this.data[x].retailerEnabled });
        } else {
          this.products.push({ _id: this.data[x]._id, qty: this.data[x].qty });
        }

      }
      console.log(this.products)
      let formData = {
        products: this.products,
        spotCoins: (this.spotCoinsInitial - this.spotCoins),
        paymentMode: this.paymentMode,
        userId: this.id,
        shippingAddress: this.custInfoObj,
        customerName: this.name,
        customerPhone: this.phone,
        deliveryfees: this.delFee
      }
      console.log(formData)
      this.loader.presentLoading("")
      this.authService.checkout(formData).then((res) => {
        this.loader.dismiss();
        this.userService.setContext('checkout POD data', {
          products: JSON.stringify(this.products),
          formData: JSON.stringify(formData),
          response: JSON.stringify(res)
        });
        let name = '[LOG] Checkout POD Response';
        var error = new Error();
        error.name = name;
        this.userService.sendException(error)
        console.log(res)
        this.navController.navigateRoot('/order-confirm');
        localStorage.setItem('cart', '[]')
      }, error => {
        this.toast.presentToast(error.msg)
        this.userService.sendException(error)
      })
    } else {
      this.toast.presentToast("Add shipping address")
    }
  }

  //Added by Divyansh Sharma to select one default address
  changeAddress(ev) {
    this.custInfoObj = this.address[ev.detail.value];

  }


  //for checkout process
  checkout() {
    if (Object.keys(this.custInfoObj).length > 0) {

      let a = [];
      for (let x in this.cartObject.productDetailArr) {
        a.push(this.cartObject.productDetailArr[x].city.toUpperCase().trim())
      }

      let abc = _.uniq(a)
      console.log(abc)
      console.log(this.custInfoObj.city.toUpperCase())

      this.userService.setContext('checkout clicked data', {
        paymentMode: this.paymentMode,
        address: JSON.stringify(a),
        cartObject: JSON.stringify(this.cartObject),
        abc: JSON.stringify(abc),
        custInfoObj: JSON.stringify(this.custInfoObj),
        city: this.custInfoObj.city.toUpperCase().trim()
      });
      let name = '[LOG] Checkout Clicked';
      var error = new Error();
      error.name = name;
      this.userService.sendException(error)

      if (abc.length == 1 && abc[0] == this.custInfoObj.city.toUpperCase().trim()) {

        this.products = [];

        if (this.address.length == 0) {
          this.toast.presentToast("Add shipping address")
        } else {

          if ((this.cartObject.totalAmount - (this.spotCoinsInitial - this.spotCoins) / 100) == 0) {
            this.paymentMode = 'POD';
            this.payPOD();
          } else {
            if (this.paymentMode == 'ONLINE') {
              this.payWithRazorCheckout();
            }
            if (this.paymentMode == 'POD') {
              this.payPOD();
            }
          }
        }
      }
      else {
        this.toast.presentToast("Some Product Is Not Deliverable In Your City, Please Check Your Cart")
      }
    }
    else {
      this.toast.presentToast("Please Add Shipping Address");
    }

  }


  //for online checkout
  payWithRazorCheckout() {
    let that = this;
    if (Object.keys(this.cartObject).length > 0) {
      this.data = this.cartObject.productDetailArr;
      this.delFee = this.cartObject.deliveryfees;
      for (var x in this.data) {
        if (localStorage.getItem('retailerEnabled') == "1") {
          this.products.push({ _id: this.data[x]._id, qty: this.data[x].qty, retailerEnabled: this.data[x].retailerEnabled });
        } else {
          this.products.push({ _id: this.data[x]._id, qty: this.data[x].qty });
        }
        // this.products.push({ _id: this.data[x]._id, qty: this.data[x].qty });
      }
      console.log(this.products)
      let formData = {
        products: this.products,
        spotCoins: (this.spotCoinsInitial - this.spotCoins),
        paymentMode: this.paymentMode,
        userId: this.id,
        shippingAddress: this.custInfoObj,
        customerName: this.name,
        customerPhone: this.phone,
        deliveryfees: this.delFee
      }
      console.log("Del fee key include in online payment", formData)
      this.loader.presentLoading("")
      this.authService.checkout(formData).then((res: any) => {
        this.loader.dismiss();
        console.log(res)
        //this.router.navigate(['/order-confirm'])
        // localStorage.removeItem('cart');
        console.log(res)
        this.result = res;
        this.userService.setLogData(this.result.orderId, { createOrder: this.result, paymentMode: 'ONLINE' })
        console.log(this.result.amount)
        var options = {
          description: 'SpotYourDeal.com',
          image: '',
          currency: 'INR',
          key: AuthConstants.RazorPay,
          order_id: this.result.orderId,
          //name:this.productObj.name,
          name: "",
          prefill: {
            email: this.email1,
            contact: this.phone,
            name: this.name
          },
          theme: {
            color: '#F37254'
          },
          modal: {
            ondismiss: function () {
              alert('dismissed')
            }
          }
        }
        // console.log(options.amount,"heelo hi")
        var successCallback = function (success) {
          console.log("Success payment ID", success)
          var razorpay_payment_id = success.razorpay_payment_id
          var razorpay_order_id = success.razorpay_order_id
          var razorpay_signature = success.razorpay_signature
          let formData = {
            razorpay_payment_id,
            razorpay_order_id,
            razorpay_signature
          }
          that.userService.updateLogData(res.orderId, { successCallback: JSON.parse(JSON.stringify(success)) })
          that.userService.onlineCheckout(formData).subscribe((verifyResp: any) => {
            that.userService.updateLogData(res.orderId, { verifyPaymentResp: JSON.parse(JSON.stringify(verifyResp)) })
            var data = verifyResp;
            if (data.razorpay_signature_verified == true) {
              console.log("success")
              localStorage.setItem('cart', '[]')
              that.navController.navigateRoot('/order-confirm');
              // that.router.navigate(['/order-confirm'])
            } else {
              that.toast.presentToast("payment failed")
            }
          }, err => {
            that.userService.updateLogData(res.orderId, { verifyPaymentError: JSON.parse(JSON.stringify(err)) })
          })
        };
        var cancelCallback = function (error) {
          // alert(error.description + ' (Error ' + error.code + ')');
          this.userService.updateLogData(res.orderId, { cancelCallback: JSON.parse(JSON.stringify(error)) })
          // alert(error.description);
        };
          // Edit By Vikash Kumar
          var rz1=new Razorpay(options, successCallback, cancelCallback)
          rz1.open()
        // RazorpayCheckout.on('payment.success', successCallback)
        // RazorpayCheckout.on('payment.cancel', cancelCallback)
        // RazorpayCheckout.open(options);
      }, error => {
        this.toast.presentToast(error.msg)
      })
    } else {
      console.log("choose shipping address")
      this.toast.presentToast("Add shipping address")
    }
  }




  selectShippingAddress(address) {
    console.log(address);
    let index = this.address.indexOf(address)
    this.radioa = index;
    this.custInfoObj = address;
  }

  openEditModel() {
    this.router.navigate(['/address'])
  }

  ///Added by Parul for View more in Address Bug no-899
  makeAddressVisible() {
    this.addressVisible = !this.addressVisible

  }

  addressVisible2() {
    this.addressVisible = false;
    this.addressVisibleLess = true;
  }

  deleteAddress(i) {
    this.address.splice(i, 1);
    let dataa = {
      address: this.address,
      dob: this.dob,
      city: this.city,
      email1: this.email1,
      name: this.name,
      id: this.id
    }
    this.userService.updateDetails(dataa).subscribe((res) => {
      this.fetchAllShippingAddress();
    })
  }

  applySpotCash() {
    if (this.spotCoinsInitial < 5000) {
      this.toast.presentToast("Minimum 5000 spotcions are required")
    }
    else {
      this.spotCashapplied = !this.spotCashapplied;

      if (this.spotCashapplied) {
        if (this.cartObject.totalAmount >= (this.spotCoinsInitial / 100)) {
          this.spotCoins = 0;
        }
        if (this.cartObject.totalAmount < (this.spotCoinsInitial / 100)) {
          this.spotCoins = ((this.spotCoinsInitial / 100) - this.cartObject.totalAmount) * 100;
        }
      } else {
        this.spotCoins = this.spotCoinsInitial
      }
    }
  }

  home() {
    this.router.navigate(['/'])
  }

}
